import { useContext } from 'react';
import { ChatContext, type ChatContextValue } from '../contexts/chatContext';

/**
 * The island's one chat, as `ChatProvider` holds it: its state, and everything
 * that can be done with it. Every component reads the same instance.
 */
export function useChat(): ChatContextValue {
  const chat = useContext(ChatContext);
  if (!chat) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return chat;
}
